import logoutPNG from "../image/Logout.png";
import { useEffect, useState } from "react";
import parse from 'html-react-parser';

function Footer(props) {
  const { logout, texte_du_client } = props;

  const [html, setHtml] = useState("")
  let htmlAsString = texte_du_client?.texte_du_client ? texte_du_client?.texte_du_client : ""
  useEffect(() => {
    setHtml(htmlAsString)
  }, [html, htmlAsString])

  return (
    <div className="marquee">
      <button className="foreground" onClick={(e) => logout(e)}>
        <img className="logo2" src={logoutPNG} alt="logout" />
      </button>
      <p>
        {parse(html)}
      </p>
    </div>
  );
}

export default Footer;
